"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Provides helper methods for working with Tenants.
 */
const TenantHelper = {
    /**
     * Is the tenant phase one where development is done?
     * @param tenant
     */
    isDevelopmentPhase(tenant) {
        if (!tenant) {
            return false;
        }
        const { phase } = tenant;
        return phase != 'prod' && phase != 'preprod' && phase != 'bench' && phase != 'demo';
    }
};
exports.default = TenantHelper;
//# sourceMappingURL=TenantHelper.js.map